import { useState, useEffect, useRef, useCallback } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useMatchStore } from '../store/useMatchStore';
import { useSendLikeStore } from '../store/useSendLikeStore';
import { preloadImages } from '../utils/preloadImages';
import { Link, useNavigate } from 'react-router-dom';
import Chat from '../components/Chat';
import location_dark from '../assets/images/location_dark.png';
import defaultimg from '../assets/images/default413.png';
import heart_dark from '../assets/images/heart_dark.png';
import ruler_dark from '../assets/images/ruler_dark.png';
import kids_dark from '../assets/images/kids_dark.png';
import briefcase_dark from '../assets/images/briefcase_dark.png';
import camera_icon from '../assets/images/camera_icon.png';
import diamond_icon from '../assets/images/diamond_icon.png';
import { hasPremiumAccess } from '../utils/subscription';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useSubscriptionStore } from '../store/useSubscriptionStore';
import useAuthStore from '../store/useAuthStore';
import { updateCachedMatchesAfterAction } from '../utils/matchCacheUtils';
import { getSizedImageUrl } from '../utils/getSizedImageUrl';
import loading from '../assets/images/loading-buffering.gif';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import React from 'react';

const MySwal = withReactContent(Swal);

/* ═══════════════════════════════════════════════
   INJECT STYLES
═══════════════════════════════════════════════ */
const injectStyles = () => {
  if (document.getElementById('dbot-styles')) return;
  const s = document.createElement('style');
  s.id = 'dbot-styles';
  s.innerHTML = `
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

    @keyframes dbotSlideIn { from{opacity:0;transform:translateY(-10px) scale(.93)} to{opacity:1;transform:translateY(0) scale(1)} }
    @keyframes dbotCursor  { 0%,100%{opacity:1} 50%{opacity:0} }
    @keyframes dbotSpeak   { 0%,100%{transform:scaleY(1)} 50%{transform:scaleY(1.9)} }
    @keyframes dbotPulse   { 0%,100%{opacity:1} 50%{opacity:.35} }
    @keyframes dbotBobSvg  { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-2.5px)} }
    @keyframes dbotHeartL1 { 0%{transform:translate(0,0) scale(1);opacity:1} 100%{transform:translate(-14px,-54px) scale(0.18);opacity:0} }
    @keyframes dbotHeartL2 { 0%{transform:translate(0,0) scale(0.82);opacity:0.9} 100%{transform:translate(-4px,-58px) scale(0.12);opacity:0} }
    @keyframes dbotHeartL3 { 0%{transform:translate(0,0) scale(0.68);opacity:0.8} 100%{transform:translate(9px,-50px) scale(0.22);opacity:0} }
    @keyframes dbotHeartR1 { 0%{transform:translate(0,0) scale(1);opacity:1} 100%{transform:translate(14px,-54px) scale(0.18);opacity:0} }
    @keyframes dbotHeartR2 { 0%{transform:translate(0,0) scale(0.82);opacity:0.9} 100%{transform:translate(4px,-58px) scale(0.12);opacity:0} }
    @keyframes dbotHeartR3 { 0%{transform:translate(0,0) scale(0.68);opacity:0.8} 100%{transform:translate(-9px,-50px) scale(0.22);opacity:0} }

    /* ── Love Diamond button animations ── */
    @keyframes ldPulse {
      0%,100%{ filter:drop-shadow(0 4px 16px rgba(192,0,26,.55)); transform:scale(1); }
      50%    { filter:drop-shadow(0 6px 24px rgba(192,0,26,.9));  transform:scale(1.06); }
    }
    @keyframes ldTap {
      0%  { transform:scale(1); }
      20% { transform:scale(0.82); }
      55% { transform:scale(1.28); }
      78% { transform:scale(0.95); }
      100%{ transform:scale(1); }
    }
    @keyframes ldFloat {
      0%  { transform:translateY(0)     scale(1);   opacity:1; }
      100%{ transform:translateY(-68px) scale(.22); opacity:0; }
    }
    @keyframes ldSpark {
      0%  { transform:translate(0,0) scale(1); opacity:1; }
      100%{ transform:translate(var(--tx),var(--ty)) scale(0); opacity:0; }
    }
    @keyframes ldRipple {
      0%  { opacity:.45; transform:scale(1);   }
      100%{ opacity:0;   transform:scale(2.4); }
    }
    /* Pop-out: image zooms from button center outward then fades */
    @keyframes ldPopOut {
      0%  { opacity:1; transform:translate(-50%,-58%) scale(1) rotate(0deg);   }
      40% { opacity:1; transform:translate(-50%,-90%) scale(1.5) rotate(-8deg); }
      100%{ opacity:0; transform:translate(-50%,-140%) scale(2.2) rotate(12deg);}
    }

    /* ── Bot SVG ── */
    .dbot-bob { animation: dbotBobSvg 3s ease-in-out infinite; }
    .dbot-hl1 { animation: dbotHeartL1 2s 0.0s  ease-out infinite; transform-origin: 23px 27px; }
    .dbot-hl2 { animation: dbotHeartL2 2s 0.65s ease-out infinite; transform-origin: 23px 27px; }
    .dbot-hl3 { animation: dbotHeartL3 2s 1.3s  ease-out infinite; transform-origin: 23px 27px; }
    .dbot-hr1 { animation: dbotHeartR1 2s 0.2s  ease-out infinite; transform-origin: 49px 27px; }
    .dbot-hr2 { animation: dbotHeartR2 2s 0.85s ease-out infinite; transform-origin: 49px 27px; }
    .dbot-hr3 { animation: dbotHeartR3 2s 1.5s  ease-out infinite; transform-origin: 49px 27px; }

    /* ── Bot popup wrapper ── */
    .dbot-wrap { position:fixed; z-index:99999; animation:dbotSlideIn .28s cubic-bezier(.34,1.2,.64,1) both; }
    .dbot-wrap::before { content:''; position:absolute; width:16px; height:9px; background:#c0001a; clip-path:polygon(50% 0%,100% 100%,0% 100%); }
    .dbot-wrap.toright::before { top:24px; left:-9px;  transform:rotate(-90deg); }
    .dbot-wrap.toleft::before  { top:24px; right:-9px; transform:rotate(90deg);  }
    .dbot-wrap.below::before   { top:-9px; left:24px; }
    .dbot-wrap.above::before   { bottom:-9px; left:24px; transform:rotate(180deg); }

    .dbot-card { background:#fff; border-radius:14px; border:1px solid rgba(0,0,0,.07); overflow:hidden; box-shadow:0 4px 8px rgba(0,0,0,.06),0 18px 52px rgba(0,0,0,.18),0 2px 10px rgba(192,0,26,.1); }
    .dbot-hd { background:linear-gradient(135deg,#c0001a 0%,#8b0000 58%,#5c0000 100%); padding:12px 14px 10px; display:flex; align-items:center; gap:10px; position:relative; overflow:visible; }
    .dbot-hd::after { content:''; position:absolute; inset:0; pointer-events:none; background-image:linear-gradient(rgba(255,255,255,.04) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,.04) 1px,transparent 1px); background-size:16px 16px; }
    .dbot-av   { position:relative; flex-shrink:0; z-index:1; overflow:visible; }
    .dbot-bars { display:flex; align-items:flex-end; gap:2px; position:absolute; bottom:-3px; right:-4px; background:rgba(0,0,0,.3); border-radius:4px; padding:2px 3px; z-index:2; }
    .dbot-b    { width:2.5px; border-radius:2px; background:#fff; transform-origin:bottom; }
    .dbot-b:nth-child(1){ height:4px;  animation:dbotSpeak .48s .00s ease-in-out infinite; }
    .dbot-b:nth-child(2){ height:9px;  animation:dbotSpeak .48s .10s ease-in-out infinite; }
    .dbot-b:nth-child(3){ height:6px;  animation:dbotSpeak .48s .20s ease-in-out infinite; }
    .dbot-b:nth-child(4){ height:3px;  animation:dbotSpeak .48s .30s ease-in-out infinite; }
    .dbot-meta { flex:1; z-index:1; min-width:0; overflow:hidden; }
    .dbot-name { font-size:11.5px; font-weight:800; color:#fff; letter-spacing:.06em; font-family:'DM Mono','Fira Code',monospace; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
    .dbot-sub  { font-size:9.5px; color:rgba(255,255,255,.7); display:flex; align-items:center; gap:4px; margin-top:2px; }
    .dbot-dot  { width:5px; height:5px; border-radius:50%; background:#6effa0; box-shadow:0 0 4px rgba(100,255,150,.85); flex-shrink:0; animation:dbotPulse 2s ease-in-out infinite; }
    .dbot-tag  { background:linear-gradient(90deg,#fff5f5,#fff); border-bottom:1px solid rgba(192,0,26,.1); padding:5px 14px; display:flex; align-items:center; gap:6px; }
    .dbot-tag-d{ width:5px; height:5px; border-radius:50%; background:#c0001a; flex-shrink:0; }
    .dbot-tag-t{ font-size:9.5px; font-weight:800; color:#c0001a; letter-spacing:.08em; }
    .dbot-body { padding:10px 14px 8px; }
    .dbot-msg  { font-size:13px; line-height:1.62; color:#1a1a1a; word-break:break-word; margin:0; }
    .dbot-msg strong { color:#c0001a; font-weight:800; }
    .dbot-cur  { display:inline-block; width:2px; height:13px; background:#c0001a; border-radius:2px; margin-left:2px; vertical-align:middle; animation:dbotCursor .65s ease-in-out infinite; }
    .dbot-ft   { padding:8px 14px 11px; display:flex; align-items:center; justify-content:space-between; gap:8px; border-top:1px solid rgba(0,0,0,.05); background:#fafafa; }
    .dbot-skip { background:none; border:none; cursor:pointer; font-size:11px; color:#c0c0c0; padding:4px 6px; border-radius:6px; transition:all .18s; }
    .dbot-skip:hover { background:#f0f0f0; color:#888; }
    .dbot-got  { background:linear-gradient(135deg,#c0001a,#8b0000); color:#fff; border:none; border-radius:8px; padding:7px 16px; font-size:12px; font-weight:800; cursor:pointer; letter-spacing:.03em; box-shadow:0 3px 12px rgba(192,0,26,.32); transition:all .18s; }
    .dbot-got:hover  { transform:translateY(-1px); box-shadow:0 5px 16px rgba(192,0,26,.46); }
    .dbot-got:active { transform:scale(.97); }

    /* ── Action buttons ── */
    .da-btn-wrap { display:flex; align-items:center; justify-content:space-around; padding:16px 8px 12px; gap:8px; }
    .da-btn-item { display:flex; flex-direction:column; align-items:center; gap:6px; }
    .da-circle-btn {
      width:52px; height:52px; border-radius:50%; border:none;
      display:flex; align-items:center; justify-content:center;
      cursor:pointer; transition:transform .15s,box-shadow .15s;
      font-size:20px; box-shadow:0 2px 10px rgba(0,0,0,0.12);
    }
    .da-circle-btn:hover  { transform:translateY(-2px); box-shadow:0 5px 16px rgba(0,0,0,0.18); }
    .da-circle-btn:active { transform:scale(.93); }
    .da-circle-btn:disabled { opacity:.65; cursor:not-allowed; transform:none; }
    .da-pass-btn { background:#e8e8e8; color:#555; }
    .da-pass-btn:hover { background:#ddd; }
    .da-msg-btn  { background:#2d3748; color:#fff; }
    .da-msg-btn:hover { background:#1a202c; }
    .da-like-btn { background:#c0001a; color:#fff; }
    .da-like-btn:hover { background:#a80017; }
    .da-like-btn.liked { background:#fee2e2; color:#c0001a; }
    .da-btn-label { font-size:12px; font-weight:600; color:#64748b; font-family:'Inter',sans-serif; white-space:nowrap; }
    .da-btn-label.liked   { color:#c0001a; }
    .da-btn-label.ld-lbl  { color:#8b0000; font-weight:700; }
    .da-btn-label.sent    { color:#2563eb; }

    /* ══ LOVE DIAMOND BUTTON ══ */
    .ld-btn-wrap {
      position: relative;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      background: none;
      border: none;
      padding: 0;
      outline: none;
      width: 58px;
      height: 58px;
    }
    .ld-btn-wrap:disabled { opacity:.65; cursor:not-allowed; }

    /* The diamond image — fills button, pulsing */
    .ld-main-img {
      width: 58px;
      height: 58px;
      object-fit: contain;
      display: block;
      animation: ldPulse 2.2s ease-in-out infinite;
      transition: transform .18s;
    }
    .ld-main-img.tapping {
      animation: ldTap .42s cubic-bezier(.34,1.4,.64,1) both;
    }
    .ld-main-img.sent {
      animation: none;
      filter: grayscale(.3) brightness(.85);
      opacity: .75;
    }

    /* Pop-out image — same image zooms out from button on tap */
    .ld-pop-img {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 58px;
      height: 58px;
      object-fit: contain;
      pointer-events: none;
      z-index: 9999;
      animation: ldPopOut .72s cubic-bezier(.22,1,.36,1) forwards;
    }

    /* Ripple */
    .ld-ripple {
      position: absolute;
      width: 58px; height: 58px;
      border-radius: 50%;
      background: rgba(192,0,26,0.2);
      pointer-events: none;
      animation: ldRipple .65s ease-out forwards;
      top: 0; left: 0;
    }

    /* Spark particles */
    .ld-spark {
      position: absolute;
      width: 7px; height: 7px;
      border-radius: 50%;
      background: linear-gradient(135deg,#c0001a,#ff6b6b);
      pointer-events: none;
      animation: ldSpark .7s ease-out forwards;
    }

    /* Float 💎 */
    .ld-float {
      position: absolute;
      font-size: 17px;
      pointer-events: none;
      z-index: 9999;
      animation: ldFloat .95s ease-out forwards;
    }

    /* ── Dashboard ── */
    .dash-section { background:#f8f5f0 !important; min-height:100vh; }
    .dash-card { background:#fff; border-radius:18px !important; border:1px solid #e8e3dc !important; box-shadow:0 2px 8px rgba(0,0,0,.06),0 8px 24px rgba(0,0,0,.06) !important; overflow:hidden; margin-bottom:24px; }
  `;
  document.head.appendChild(s);
};

/* ═══════════════════════════════════════════════
   BOT FACE SVG
═══════════════════════════════════════════════ */
const BotFaceSVG: React.FC = () => (
  <svg width="64" height="64" viewBox="0 0 72 72" fill="none" style={{ overflow:'visible' }}>
    <defs>
      <style>{`
        .dbot-bob { animation: dbotBobSvg 3s ease-in-out infinite; }
        .dbot-hl1 { animation: dbotHeartL1 2s 0.0s  ease-out infinite; transform-origin: 23px 27px; }
        .dbot-hl2 { animation: dbotHeartL2 2s 0.65s ease-out infinite; transform-origin: 23px 27px; }
        .dbot-hl3 { animation: dbotHeartL3 2s 1.3s  ease-out infinite; transform-origin: 23px 27px; }
        .dbot-hr1 { animation: dbotHeartR1 2s 0.2s  ease-out infinite; transform-origin: 49px 27px; }
        .dbot-hr2 { animation: dbotHeartR2 2s 0.85s ease-out infinite; transform-origin: 49px 27px; }
        .dbot-hr3 { animation: dbotHeartR3 2s 1.5s  ease-out infinite; transform-origin: 49px 27px; }
      `}</style>
    </defs>
    <g className="dbot-bob">
      <line x1="36" y1="10" x2="36" y2="3" stroke="rgba(255,255,255,0.82)" strokeWidth="2.5" strokeLinecap="round"/>
      <circle cx="36" cy="2" r="3.2" fill="rgba(255,255,255,0.9)"/>
      <rect x="7" y="10" width="58" height="46" rx="15" fill="rgba(255,255,255,0.97)"/>
      <circle cx="7"  cy="32" r="5.5" fill="rgba(255,255,255,0.85)" stroke="rgba(192,0,26,0.45)" strokeWidth="1.2"/>
      <circle cx="65" cy="32" r="5.5" fill="rgba(255,255,255,0.85)" stroke="rgba(192,0,26,0.45)" strokeWidth="1.2"/>
      <rect x="11" y="17" width="24" height="20" rx="9" fill="#c0001a"/>
      <rect x="37" y="17" width="24" height="20" rx="9" fill="#8b0000"/>
      <ellipse cx="23" cy="27" rx="9" ry="8" fill="white"/>
      <ellipse cx="49" cy="27" rx="9" ry="8" fill="white"/>
      <g className="dbot-hl1"><path d="M23,33 C23,33 12,23 12,17 C12,13 17,11 23,17 C29,11 34,13 34,17 C34,23 23,33 23,33Z" fill="#ff3d6b"/></g>
      <g className="dbot-hl2"><path d="M23,33 C23,33 12,23 12,17 C12,13 17,11 23,17 C29,11 34,13 34,17 C34,23 23,33 23,33Z" fill="#c0001a" opacity="0.88"/></g>
      <g className="dbot-hl3"><path d="M23,33 C23,33 12,23 12,17 C12,13 17,11 23,17 C29,11 34,13 34,17 C34,23 23,33 23,33Z" fill="#ff7099"/></g>
      <g className="dbot-hr1"><path d="M49,33 C49,33 38,23 38,17 C38,13 43,11 49,17 C55,11 60,13 60,17 C60,23 49,33 49,33Z" fill="#ff3d6b"/></g>
      <g className="dbot-hr2"><path d="M49,33 C49,33 38,23 38,17 C38,13 43,11 49,17 C55,11 60,13 60,17 C60,23 49,33 49,33Z" fill="#c0001a" opacity="0.88"/></g>
      <g className="dbot-hr3"><path d="M49,33 C49,33 38,23 38,17 C38,13 43,11 49,17 C55,11 60,13 60,17 C60,23 49,33 49,33Z" fill="#ff7099"/></g>
      <path d="M16,46 Q36,60 56,46" stroke="#c0001a" strokeWidth="2.8" strokeLinecap="round" fill="none"/>
      <ellipse cx="12" cy="44" rx="6" ry="4" fill="rgba(255,100,100,0.2)"/>
      <ellipse cx="60" cy="44" rx="6" ry="4" fill="rgba(255,100,100,0.2)"/>
      <line x1="7"  y1="28" x2="2"  y2="23" stroke="rgba(255,255,255,0.78)" strokeWidth="2.4" strokeLinecap="round"/>
      <line x1="7"  y1="36" x2="2"  y2="39" stroke="rgba(255,255,255,0.78)" strokeWidth="2.4" strokeLinecap="round"/>
      <line x1="65" y1="28" x2="70" y2="23" stroke="rgba(255,255,255,0.78)" strokeWidth="2.4" strokeLinecap="round"/>
      <line x1="65" y1="36" x2="70" y2="39" stroke="rgba(255,255,255,0.78)" strokeWidth="2.4" strokeLinecap="round"/>
    </g>
  </svg>
);

/* ═══════════════════════════════════════════════
   DIAMOND BOT POPUP
═══════════════════════════════════════════════ */
type BotSide = 'below' | 'above' | 'toright' | 'toleft';

const PLAIN_MSG = "Press Love Diamond to stand out! 💎 Love Diamond matches get 3× more replies — you'll jump straight to the top of their list!";
const HTML_MSG  = (
  <><strong>Press Love Diamond to stand out!</strong> 💎 Love Diamond matches get{' '}
  <strong>3× more replies</strong> — you'll jump straight to the top of their list!</>
);

interface DiamondBotProps {
  anchorRef: React.RefObject<HTMLButtonElement | null>;
  onClose:   () => void;
}

const DiamondBot: React.FC<DiamondBotProps> = ({ anchorRef, onClose }) => {
  const PW = 310, GAP = 12, POPUP_H = 240;
  const [pos,        setPos]        = useState<{ top:number; left:number; width:number } | null>(null);
  const [activeSide, setActiveSide] = useState<BotSide>('toright');
  const [displayed,  setDisplayed]  = useState('');
  const [done,       setDone]       = useState(false);
  const [status,     setStatus]     = useState('typing...');
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const retryRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const calcPos = useCallback((): boolean => {
    if (!anchorRef.current) return false;
    const r = anchorRef.current.getBoundingClientRect();
    const vw = window.innerWidth, vh = window.innerHeight;
    if (r.width === 0 && r.height === 0) return false;
    if (vw < 768) {
      const popW = Math.min(vw - 24, 320);
      let top: number, side: BotSide;
      if (r.top - POPUP_H - GAP >= 8)             { top = r.top - POPUP_H - GAP; side = 'above'; }
      else if (r.bottom + POPUP_H + GAP <= vh - 8) { top = r.bottom + GAP;        side = 'below'; }
      else                                          { top = Math.max(8, vh - POPUP_H - 16); side = 'above'; }
      setActiveSide(side); setPos({ top, left: Math.max(12, (vw - popW) / 2), width: popW }); return true;
    }
    let side: BotSide = 'toright';
    let left = r.right + GAP;
    if (left + PW > vw - 12) { left = r.left - PW - GAP; side = 'toleft'; }
    left = Math.max(12, Math.min(left, vw - PW - 12));
    let top = r.top + r.height / 2;
    top = Math.min(top, vh - POPUP_H - 8); top = Math.max(top, 8);
    setActiveSide(side); setPos({ top, left, width: PW }); return true;
  }, [anchorRef]);

  useEffect(() => {
    let att = 0;
    if (retryRef.current) clearTimeout(retryRef.current);
    setPos(null);
    const tryCalc = () => { if (!calcPos() && att++ < 50) retryRef.current = setTimeout(tryCalc, 80); };
    tryCalc();
    window.addEventListener('resize', calcPos);
    window.addEventListener('scroll', calcPos, true);
    return () => {
      if (retryRef.current) clearTimeout(retryRef.current);
      window.removeEventListener('resize', calcPos);
      window.removeEventListener('scroll', calcPos, true);
    };
  }, [calcPos]);

  useEffect(() => {
    setDisplayed(''); setDone(false); setStatus('typing...');
    let i = 0;
    const tick = () => {
      if (i <= PLAIN_MSG.length) { setDisplayed(PLAIN_MSG.slice(0, i++)); timerRef.current = setTimeout(tick, 18); }
      else { setDone(true); setStatus('Online — here to guide you!'); }
    };
    tick();
    return () => { if (timerRef.current) clearTimeout(timerRef.current); };
  }, []);

  useEffect(() => {
    const t = setTimeout(onClose, 9000);
    return () => clearTimeout(t);
  }, [onClose]);

  if (!pos) return null;
  const isSide = activeSide === 'toright' || activeSide === 'toleft';

  return (
    <>
      <div onClick={onClose} style={{ position:'fixed', inset:0, zIndex:99990 }}/>
      <div
        className={`dbot-wrap ${activeSide}`}
        style={{ top:pos.top, left:pos.left, width:pos.width, transform: isSide ? 'translateY(-50%)' : 'none' }}
      >
        <div className="dbot-card" style={{ width:'100%' }}>
          <div className="dbot-hd">
            <div className="dbot-av">
              <BotFaceSVG/>
              <div className="dbot-bars"><div className="dbot-b"/><div className="dbot-b"/><div className="dbot-b"/><div className="dbot-b"/></div>
            </div>
            <div className="dbot-meta">
              <div className="dbot-name">SLAMMM GUIDE</div>
              <div className="dbot-sub"><div className="dbot-dot"/><span>{status}</span></div>
            </div>
          </div>
          <div className="dbot-tag"><div className="dbot-tag-d"/><div className="dbot-tag-t">💎 LOVE DIAMOND FEATURE</div></div>
          <div className="dbot-body">
            {done
              ? <p className="dbot-msg">{HTML_MSG}</p>
              : <p className="dbot-msg">{displayed}<span className="dbot-cur"/></p>
            }
          </div>
          <div className="dbot-ft">
            <button className="dbot-skip" onClick={onClose}>Dismiss</button>
            <button className="dbot-got"  onClick={onClose}>Got it 💎</button>
          </div>
        </div>
      </div>
    </>
  );
};



/* ═══════════════════════════════════════════════
   LOVE DIAMOND BUTTON
═══════════════════════════════════════════════ */
interface LoveDiamondBtnProps {
  matchId:     number;
  sent:        boolean;
  loading:     boolean;
  onSend:      () => void;
  autoOpenBot: boolean;
}

const LoveDiamondButton: React.FC<LoveDiamondBtnProps> = ({ sent, loading: isLoading, onSend, autoOpenBot }) => {
  const btnRef    = useRef<HTMLButtonElement>(null);
  const [botOpen, setBotOpen] = useState(false);
  const [tapping, setTapping] = useState(false);
  const [showPop, setShowPop] = useState(false);
  const [ripples, setRipples] = useState<number[]>([]);
  const [sparks,  setSparks]  = useState<{ id:number; tx:string; ty:string }[]>([]);
  const [floats,  setFloats]  = useState<{ id:number; left:string }[]>([]);

  useEffect(() => {
    if (!autoOpenBot || sent) return;
    const t = setTimeout(() => setBotOpen(true), 1400);
    return () => clearTimeout(t);
  }, [autoOpenBot, sent]);

  const handleClick = () => {
    if (sent || isLoading) return;
    setBotOpen(false);

    setTapping(true);
    setTimeout(() => setTapping(false), 450);

    /* Pop-out — same image zooms up and fades */
    setShowPop(true);
    setTimeout(() => setShowPop(false), 780);

    const rid = Date.now();
    setRipples(p => [...p, rid]);
    setTimeout(() => setRipples(p => p.filter(x => x !== rid)), 700);

    const DIRS = [
      { tx:'-32px', ty:'-30px' }, { tx:'32px', ty:'-30px' },
      { tx:'-34px', ty:'10px'  }, { tx:'34px', ty:'10px'  },
      { tx:'0px',   ty:'-40px' }, { tx:'-18px',ty:'22px'  },
      { tx:'18px',  ty:'22px'  },
    ];
    setSparks(DIRS.map((d, i) => ({ id: Date.now() + i, ...d })));
    setTimeout(() => setSparks([]), 800);

    setFloats(Array.from({ length: 3 }, (_, i) => ({ id: Date.now() + 100 + i, left: `${4 + i * 14}px` })));
    setTimeout(() => setFloats([]), 1050);

    onSend();
  };

  return (
    <div className="da-btn-item">
      {botOpen && <DiamondBot anchorRef={btnRef} onClose={() => setBotOpen(false)}/>}

      <div style={{ position:'relative', display:'inline-flex', alignItems:'center', justifyContent:'center' }}>
        {ripples.map(r => <div key={r} className="ld-ripple"/>)}
        {sparks.map(p => (
          <span key={p.id} className="ld-spark"
            style={{ '--tx':p.tx, '--ty':p.ty, top:'50%', left:'50%', marginTop:'-3.5px', marginLeft:'-3.5px' } as React.CSSProperties}
          />
        ))}
        {floats.map(f => (
          <span key={f.id} className="ld-float" style={{ left:f.left, bottom:'100%' }}>💎</span>
        ))}

        {/* Pop-out — same diamond_icon zooms up from button */}
        {showPop && (
          <img src={diamond_icon} alt="" className="ld-pop-img"/>
        )}

        {/* Button — ONLY the diamond_icon image, nothing else */}
        <button
          ref={btnRef}
          onClick={handleClick}
          disabled={isLoading || sent}
          className="ld-btn-wrap"
          title="Love Diamond"
        >
          <img
            src={diamond_icon}
            alt="Love Diamond"
            className={`ld-main-img${tapping ? ' tapping' : ''}${sent ? ' sent' : ''}`}
          />
        </button>
      </div>

      <span className={`da-btn-label${sent ? ' sent' : ' ld-lbl'}`}>
        {sent ? 'Sent ✓' : 'Love Diamond'}
      </span>
    </div>
  );
};

/* ═══════════════════════════════════════════════
   DASHBOARD — MAIN COMPONENT
═══════════════════════════════════════════════ */
const Dashboard = () => {
  const { rows, cachedMatches, getMatch, strikeout } = useMatchStore();
  const { loadinglike, sendLike, sendDiamond }       = useSendLikeStore();
  const navigate = useNavigate();

  const [imagesLoaded,     setImagesLoaded]     = useState(false);
  const [showMessaging,    setShowMessaging]     = useState(false);
  const [currentRecipient, setCurrentRecipient] = useState<any>(null);
  const [resolvedImageMap, setResolvedImageMap] = useState<any>({});
  const [likedUsers,       setLikedUsers]       = useState<Set<number>>(new Set());
  const [diamondUsers,     setDiamondUsers]     = useState<Set<number>>(new Set());
  const [botShownForId,    setBotShownForId]    = useState<number | null>(null);

  const { paymentDetails, getSubscription } = useSubscriptionStore();
  const authStore = useAuthStore.getState();
  const isPremium = hasPremiumAccess(paymentDetails);

  useEffect(() => {
    injectStyles();
    getMatch(-1);
    getSubscription(authStore.user?.id);
  }, []);

  useEffect(() => {
    if (rows.length > 0 && botShownForId === null) setBotShownForId(rows[0].id);
  }, [rows]);

  useEffect(() => {
    (async () => {
      const matches = rows.concat(cachedMatches.slice(0, 10));
      const entries = await Promise.all(
        matches.map(async m => {
          const url = await getSizedImageUrl(m.picture, '389x438');
          return [m.id, url || m.pic || defaultimg];
        })
      );
      const imageMap = Object.fromEntries(entries);
      setResolvedImageMap(imageMap);
      await preloadImages(Object.values(imageMap));
      setImagesLoaded(true);
    })();
  }, [rows, cachedMatches]);

  const handleStrikeout = async (id: any) => {
    strikeout(id);
    await updateCachedMatchesAfterAction(id);
  };

  const handleSendLike = async (id: any) => {
    const ok = await sendLike(id, 50, '', '');
    if (!ok) { showUpgradePlanAlert(); return; }
    setLikedUsers(p => new Set(p).add(id));
    toast.success('Liked Successfully! ❤️', { position:'top-right', autoClose:3000 });
    await updateCachedMatchesAfterAction(id);
  };

  const handleSendDiamond = async (id: any) => {
    const ok = await sendDiamond(id);
    if (!ok) {
      MySwal.fire({
        html: (
          <div className="text-center">
            <img src={diamond_icon} alt="Diamond" style={{ width:'40px', marginBottom:'10px' }}/>
            <h3>Limit Reached</h3>
            <p>You've used all your Love Diamonds for today.</p>
            <div className="d-flex justify-content-center gap-2">
              <button className="btn btn-secondary" onClick={() => MySwal.close()}>Close</button>
              <button className="btn btn-primary"   onClick={() => { MySwal.close(); navigate('/settings#subscription'); }}>Upgrade Now</button>
            </div>
          </div>
        ),
        showConfirmButton:false, showCloseButton:true,
        customClass:{ popup:'bg-light p-4 rounded', closeButton:'btn-close position-absolute top-0 end-0 m-3' },
      });
      return;
    }
    setDiamondUsers(p => new Set(p).add(id));
    setLikedUsers  (p => new Set(p).add(id));
    toast(() => (
      <div style={{ display:'flex', alignItems:'center', gap:'8px' }}>
        <img src={diamond_icon} alt="" style={{ width:'20px', height:'20px' }}/>
        <span>Love Diamond Sent Successfully!</span>
      </div>
    ), { position:'top-right', autoClose:3000, style:{ background:'#fff0f0', color:'#8b0000', fontWeight:500 } });
    await updateCachedMatchesAfterAction(id);
  };

  const showUpgradePlanAlert = () => {
    MySwal.fire({
      html: (
        <div className="text-center">
          <h3>Upgrade Plan</h3>
          <p>Upgrade your plan to send more messages.</p>
          <button className="btn btn-primary" onClick={() => { MySwal.close(); navigate('/settings#subscription'); }}>Upgrade Now</button>
        </div>
      ),
      showConfirmButton:false,
    });
  };

  return (
    <section className="dash-section py-60">
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            {rows.map((match) => (
              <div key={match.id} className="dash-card">
                <div className="row g-0">

                  {/* Photo */}
                  <div className="col-md-6">
                    <Link to={`/profile/${match.id}`}>
                      <div className="dp_list_img_box position-relative">
                        {match.is_diamond && (
                          <span className="diamond_badge" style={{ display:'inline-flex', alignItems:'center', gap:'4px' }}>
                            <img src={diamond_icon} alt="" style={{ width:'16px', height:'16px', objectFit:'contain' }}/>
                            Top
                          </span>
                        )}
                        <img
                          src={imagesLoaded ? (resolvedImageMap[match.id] || loading) : loading}
                          className="img-fluid w-100"
                          style={{ height:'400px', objectFit:'cover' }}
                          alt={match.first_name}
                        />
                        <span className="dp_list_box_span">
                          {match.photo_count || 1}
                          <img src={camera_icon} alt=""/>
                        </span>
                      </div>
                    </Link>
                  </div>

                  {/* Info + Actions */}
                  <div className="col-md-6">
                    <div className="dp_list_profile_info p-4">
                      <h2 className="mb-3">{match.first_name}, {match.age}</h2>
                      <ul className="list-unstyled mb-4">
                        <li className="mb-2"><img src={location_dark}  className="me-2" alt=""/>{match.city}, {match.distance.toFixed(0)} miles</li>
                        <li className="mb-2"><img src={heart_dark}     className="me-2" alt=""/>{match.relationship}</li>
                        <li className="mb-2"><img src={ruler_dark}     className="me-2" alt=""/>{match.height}</li>
                        <li className="mb-2"><img src={kids_dark}      className="me-2" alt=""/>{match.kids}</li>
                        <li className="mb-2"><img src={briefcase_dark} className="me-2" alt=""/>{match.occupation}</li>
                      </ul>

                      <div className="da-btn-wrap">

                        {/* Pass */}
                        <div className="da-btn-item">
                          <button className="da-circle-btn da-pass-btn" onClick={() => handleStrikeout(match.id)} title="Pass">
                            ✕
                          </button>
                          <span className="da-btn-label">Pass</span>
                        </div>

                        {/* Message */}
                        <div className="da-btn-item">
                          <button
                            className="da-circle-btn da-msg-btn"
                            onClick={() => {
                              if (isPremium) { setShowMessaging(true); setCurrentRecipient(match); }
                              else showUpgradePlanAlert();
                            }}
                            title="Message"
                          >
                            <i className="fa-solid fa-paper-plane" style={{ fontSize:18 }}/>
                          </button>
                          <span className="da-btn-label">Message</span>
                        </div>

                        {/* Like */}
                        <div className="da-btn-item">
                          <button
                            className={`da-circle-btn da-like-btn${likedUsers.has(match.id) ? ' liked' : ''}`}
                            onClick={() => handleSendLike(match.id)}
                            disabled={loadinglike || likedUsers.has(match.id)}
                            title="Like"
                          >
                            <i className="fa-solid fa-heart" style={{ fontSize:20 }}/>
                          </button>
                          <span className={`da-btn-label${likedUsers.has(match.id) ? ' liked' : ''}`}>
                            {likedUsers.has(match.id) ? 'Liked' : 'Like'}
                          </span>
                        </div>

                        {/* Love Diamond */}
                        <LoveDiamondButton
                          matchId={match.id}
                          sent={diamondUsers.has(match.id)}
                          loading={loadinglike}
                          onSend={() => handleSendDiamond(match.id)}
                          autoOpenBot={match.id === botShownForId}
                        />

                      </div>
                    </div>
                  </div>

                </div>
              </div>
            ))}
          </div>
        </div>

        {showMessaging && currentRecipient && (
          <Chat
            toUser={currentRecipient.id}
            name={`${currentRecipient.first_name}, ${currentRecipient.age}`}
            city={currentRecipient.city}
            state={currentRecipient.state}
            distance={currentRecipient.distance}
            pic={currentRecipient.picture || currentRecipient.pic}
            show={showMessaging}
            handleClose={() => setShowMessaging(false)}
          />
        )}
      </div>
    </section>
  );
};

export default Dashboard;